<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="policyList"
      style="width: 100.1%;"
    ></Table>
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";
import TableExpand from "./TableExpand";

var tablePolicyResourceVue = {};
export default {
  name: "TablePolicyResource",
  data() {
    return {
      companyId: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.IAM.Policy.AccountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.IAM.Policy.AccountId"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.IAM.Policy.PolicyName"),
          key: "policyName"
        },
        {
          title: this.$t("RAM.AWS.IAM.Policy.PolicyType"),
          key: "policyTypeName"
        }
        // {
        //     title: 'JSON',
        //     key: 'json'
        // }
      ],
      policyList: []
    };
  },
  beforeCreate: function() {
    tablePolicyResourceVue = this;
  },
  created() {
    eventBus.$on("companyId", function(companyId) {
      tablePolicyResourceVue.companyId = companyId;
    });
    eventBus.$on("iamPolicyName", function(iamPolicyName) {
      tablePolicyResourceVue.iamPolicyName = iamPolicyName;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tablePolicyResourceVue.getDate();
    },
    // 显示数据
    getDate: function() {
      tablePolicyResourceVue.$api.resourceManagement
        .pagingQueryAwsIamPolicy({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tablePolicyResourceVue.companyId,
          iamPolicyName: tablePolicyResourceVue.iamPolicyName
        })
        .then(res => {
          this.policyList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tablePolicyResourceVue.getDate();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tablePolicyResourceVue.getDate();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/policy/TablePolicyResource.vue